import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../loader';
import 'react-rangeslider/lib/index.css';
import "react-phone-number-input/style.css";
import { sendMessageToAbandonCustomers, abandonCustomersCount } from "../../actions/customers";

const $ = window.$;
const initialState={
  currentFormNotValid: false,
  petId: 'Specific',
  customPetId: '',
  message: '',
  loading: false,
  customerCount: null,
};
let formdata = {};
class MessageToAbandonCustomers extends React.Component {
  constructor(props) {
    super(props);
  }

  state = initialState;

  submitMessage = async(e) => {
    e.preventDefault();
    this.setState({loading:true});
    
    if (this.validateForm()) {
        let data = Object.values(formdata).map(key => {
            if (key !== null && key !== '') {
                return true;
            }
            else {
                return false;
            }
        });

        if (!data.includes(false)) {
            this.props.sendMessageToAbandonCustomers(formdata);
        }else {
            this.setState({ currentFormNotValid: true });
            this.setState({ loading: false });
            NotificationManager.warning("Please check input details again.");
        }
    }
  }
  validateForm(){
    const data = {
      petId: this.state.petId,
      message: this.state.message,
    }

    if(this.state.petId === "Specific"){
        data["customPetId"] = this.state.customPetId;
    }
    
    formdata = Object.assign({},data);
    return true;
  }
  changeVal = (event) => {
    if(event.target.dataset.limit){
      if(event.target.dataset.limit >= event.target.value.length){
        this.setState({[event.target.name]: event.target.value, customerCount: null});
      }else{
        event.target.value = event.target.value.slice(0, event.target.dataset.limit);
      }
    }else{
      this.setState({[event.target.name]: event.target.value, customerCount: null});
    }

  }

  changeValCheckBox = (event) => {
    this.setState({[event.target.name]: event.target.checked, customerCount: null});
  }

  resetState = () => {
    this.setState(initialState);
  }

  componentWillReceiveProps = (nextProps) => {
    if (
        nextProps.data.customersReducer.messageToAbandonCustomers !==
        this.props.data.customersReducer.messageToAbandonCustomers
      ) {
        this.setState(initialState);
        let messageToAbandonCustomers = nextProps.data.customersReducer.messageToAbandonCustomers;
        let messageLength = messageToAbandonCustomers && messageToAbandonCustomers.length;
        NotificationManager.success("Message Sent to "+ messageLength +" Customers.");
        
        $('#message-to-abandon-customers').modal('hide');
      }

    if (
      nextProps.data.customersReducer.messageToAbandonCustomersCount !==
      this.props.data.customersReducer.messageToAbandonCustomersCount
    ) {
      let abandonCustomers = nextProps.data.customersReducer.messageToAbandonCustomersCount;
      let abandonCustomersLength = abandonCustomers && abandonCustomers.length;
      this.setState({customerCount: abandonCustomersLength});
    } 

    if (
      nextProps.data.customersReducer.messageToAbandonCustomersError !==
      this.props.data.customersReducer.messageToAbandonCustomersError
    ) {
      let errorMessage = nextProps.data.customersReducer.messageToAbandonCustomersError && nextProps.data.customersReducer.messageToAbandonCustomersError.details
      NotificationManager.error(errorMessage);
    } 
  }

  getAbandonCustomerCount = () => {
    if (this.validateForm()) {
        let data = Object.values(formdata).map(key => {
            if (key !== null && key !== '') {
                return true;
            }
            else {
                return false;
            }
        });

        if (!data.includes(false)) {
          let params = formdata;
          params["getCount"] = true;
          this.props.abandonCustomersCount(params);
        }else {
            this.setState({ currentFormNotValid: true });
            this.setState({ loading: false });
            NotificationManager.warning("Please check input details again.");
        }
    }
    
  }

  render() {
    const {petId, message, customPetId, customerCount} = this.state;

    return (
      <div className="modal fade show" id="message-to-abandon-customers" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            
              <form onSubmit={this.submitMessage} className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Message Abandon Customers</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  
                    <div className="row">
                      <div className="col-xl-8 offset-xl-2">
                          <div className="m-form__section m-form__section--first">
                          <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Send to</legend>
                              <div className="form-group m-form__group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label">* Pet ID:</label>
                                    <div className="col-xl-9 col-lg-9">
                                    
                                        <select className="form-control m-input" onChange={this.changeVal} name="petId" value={petId} id="petId">
                                            <option>All</option>
                                            <option selected="selected">Specific</option>
                                        </select>
                                        { petId === "Specific" ? 
                                        <>
                                        <br/>
                                        <input type="text" name="customPetId" onChange={this.changeVal} className="form-control m-input" placeholder="" value={customPetId}/>
                                        <span className={formdata.customPetId===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter the pet id</span>
                                        </> : <span className='m-form__help'>Please select option</span>
                                        }
                                  </div>
                              </div>
                            </fieldset>  
                            <div className="form-group m-form__group row">
                              <label className="col-3 col-lg-3 col-form-label">* Message:</label>
                              <div className="col-9 col-lg-9">
                                <textarea name="message" onChange={this.changeVal} className="form-control m-input" data-limit="250" value={message} />
                                <span className="row">
                                  <span className={formdata.message===null&&this.state.currentFormNotValid?'m-form__help_danger col-xl-6 col-lg-6':'m-form__help col-xl-6 col-lg-6'}>Please enter the message</span>
                                  <span className='m-form__help col-xl-6 col-lg-6' style={{textAlign: "right"}}>{message !== null ? message.length : 0}/250</span>
                                </span>
                              </div>
                            </div>
                            <div className="form-group m-form__group row">
                              <div className="col-xs-3 col-lg-3 col-form-label"></div>
                              <div className="col-xs-9 col-lg-9">
                                <button type="button" className="btn btn-secondary m-btn--pill" onClick={this.getAbandonCustomerCount} style={{border: "1px #afafaf solid"}}>Get Customer Count</button>
                                {customerCount !== null ? 
                                  <>
                                    {customerCount > 0 ?
                                      <span className='m-form__help' style={{fontSize: "13px", width: "100%"}}>The message will be sent to <span className="m-badge m-badge--success mx-auto my-0 px-4" style={{fontWeight: "bold"}}>{customerCount}</span>.</span>
                                      : 
                                      <span className='m-form__help' style={{fontSize: "13px", width: "100%"}}>No Abandon Customers Found.</span>
                                    }
                                  </>
                                  : ""
                                }
                                
                              </div>
                            </div>
                          </div>	          
                      </div>
                    </div>
                </div>
                <div className="modal-footer">
                  {this.state.loading == false ?
                    <div>
                      <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Close</button>
                      <button type="submit" className="btn btn-primary m-btn--pill" disabled={customerCount === null || customerCount === 0 ? true : false}>Send</button>
                    </div>
                    :
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  }
                </div>
              </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
    data: state
});

const mapDispatchToProps = dispatch => ({
  sendMessageToAbandonCustomers: (data) => {
      dispatch(sendMessageToAbandonCustomers(data));
  },
  abandonCustomersCount: (data) => {
    dispatch(abandonCustomersCount(data));
  }
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessageToAbandonCustomers));
